import { render, staticRenderFns } from "./CustomerDefaulterInvoiceList.vue?vue&type=template&id=2a70ec94&lang=pug&"
import script from "./CustomerDefaulterInvoiceList.vue?vue&type=script&lang=js&"
export * from "./CustomerDefaulterInvoiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CustomerDefaulterInvoiceList.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
installComponents(component, {
  VIcon,
})
